import type { Container, Operation } from '@packages/core/container';

import { Ssm5Client } from '@packages/clients';

/** Parameters of {@link GetConnectionStatus}. */
export type GetConnectionStatusParams = {
    /** The Cloud Connector ID the connection runs through. */
    cloudConnectorId: string;
    /** Aborts the check. */
    signal?: AbortSignal;
};

/** Check whether an SSM5 connection is still open, so an expired one is not offered as live. */
export class GetConnectionStatus implements Operation {
    /**
     * Register this operation with the SSM5 client as its dependency.
     *
     * @param container - the container to register in
     */
    static registerInContainer(container: Container): void {
        container.register(GetConnectionStatus, [Ssm5Client]);
    }

    /** @param client - the SSM5 API client */
    constructor(private client: Ssm5Client) {}

    /**
     * Run the check.
     *
     * @param params - {@link GetConnectionStatusParams}
     * @returns whether the connection is still open; rejects when aborted
     */
    async exec({ cloudConnectorId, signal }: GetConnectionStatusParams): Promise<boolean> {
        const { isConnected } = await this.client.getConnectionStatus({ cloudConnectorId }, signal);

        return isConnected;
    }
}
